import React, { useState, useEffect, useContext } from 'react';
import { Button, Row, Col, Modal, ModalHeader, ModalBody, ModalFooter, Input } from 'reactstrap';
import { ThemeContext } from '../../contexts/ThemeContext';
import { PsychometricContext } from '../../contexts/PsychometricContext';

import PsychometricIndividualNavbar from './PsychometricIndividualNavbar';
import Footer from '../general/Footer';
import PsychometricService from '../../services/PsychometricService';
import Alert from "react-s-alert";
import html2pdf from 'html2pdf.js';
import PsychometricTestPDFLayout from "./PsychometricTestPDFLayout";
import ReactDOMServer from "react-dom/server";
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

const PyschometricIndividualHomePage = props => {
   
    const { theme } = useContext(ThemeContext);
    const { signedEmail} = useContext(PsychometricContext); 

    // states
    const [individual, setIndividual] = useState({
        firstName: '',
        lastName: '',
        email: '',
        mobile: '',
        isStudent: null
    });

    const [modal, setModal] = useState(false); 
    const toggleModal = () => setModal(!modal); 
    const [user, setUser] = useState(null);
   
    useEffect(() => {
        if (signedEmail) {
            PsychometricService.getPsychometricIndividual(signedEmail)
                .then(data => {
                    setUser(data.user);
                    const userData = data.user || data;

                    setIndividual({
                        firstName: userData.firstName || '',
                        lastName: userData.lastName || '',
                        email: userData.email || '',
                        mobile: userData.mobile || '',
                        isStudent: userData.isStudent || true,
                    });
                })
                .catch(err => {
                    console.error('Error fetching individual details:', err);
                });
        }
    }, [signedEmail]);

    const generatePDF = async (userData) => {
        try {
         
          // Create a temporary div to render the PDF layout
          const element = document.createElement('div');
          element.innerHTML = ReactDOMServer.renderToString(
            <PsychometricTestPDFLayout userData={userData} />
          );
          document.body.appendChild(element);
    
          const opt = {
            margin: 10,
            filename: `psychometric-report-${userData.firstName}-${userData.lastName}.pdf`,
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: { 
              scale: 2,
              useCORS: true,
              logging: true
            },
            jsPDF: { 
              unit: 'mm', 
              format: 'a4', 
              orientation: 'portrait' 
            },
            output: 'blob'
          };
    
          try {
            // Generate PDF as blob
            const pdfBlob = await html2pdf().set(opt).from(element).save().output('blob');
            
            // Create blob URL
            const blobUrl = URL.createObjectURL(pdfBlob);
            
            // Open in new tab
            window.open(blobUrl, '_blank');
            
            // Clean up blob URL after a delay
            setTimeout(() => URL.revokeObjectURL(blobUrl), 100);
            
          } catch (error) {
            console.error("Error in PDF generation:", error);
          } finally {
            // Clean up the temporary element
            document.body.removeChild(element);
          }
        } catch (error) {
          console.error("Error generating PDF:", error);
          Alert.error("Failed to generate PDF report");
        }
      };
   
    const handleUpdate = () => {
       
        PsychometricService.updateIndividualByDetails(individual.email, individual)
            .then(response => {
                toggleModal(); 
            })
            .catch(err => {
                console.error('Error updating individual:', err);
            });

    };


    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setIndividual(prevIndividual => ({
            ...prevIndividual,
            [name]: name === 'isStudent' ? value === 'true' : value
        }));

    };

    const handlePhoneChange = e => {
        setIndividual({ ...individual, mobile: e });
    };

    return (
        <div>
            <PsychometricIndividualNavbar />
            <hr style={{ margin: '20px 0' }} />
            <div id="individualProfileDiv" className="px-3 py-5 container">
                <div className="row justify-content-center">
                    <div className="col-md-8">
                        <h2 id="individualProfile" style={{ ...theme.heading, marginBottom: '20px', textAlign: 'center' }}>Individual Profile</h2>
                        <Row style={{ marginBottom: '20px' }}>
                            <Col md={4}><strong>First Name:</strong></Col>
                            <Col md={8}>{individual.firstName}</Col>
                        </Row>
                        <Row style={{ marginBottom: '20px' }}>
                            <Col md={4}><strong>Last Name:</strong></Col>
                            <Col md={8}>{individual.lastName}</Col>
                        </Row>
                        <Row style={{ marginBottom: '20px' }}>
                            <Col md={4}><strong>Email:</strong></Col>
                            <Col md={8}>{individual.email}</Col>
                        </Row>
                        <Row style={{ marginBottom: '20px' }}>
                            <Col md={4}><strong>Mobile:</strong></Col>
                            <Col md={8}>
                                <PhoneInput
                                    disabled={true}
                                    placeholder="+91 98765-43120"
                                    inputClass="form-control"
                                    inputStyle={{...theme.formInput, background: 'transparent', border: 'none', boxShadow: 'none'}}
                                    country="in"
                                    disableDropdown={true}
                                    value={individual.mobile}
                                    enableSearch={true}
                                />
                            </Col>
                        </Row>
                        <Row style={{ marginBottom: '20px' }}>
                            <Col md={4}><strong>Test Type:</strong></Col>
                            <Col md={8}>{individual.isStudent ? 'Student' : 'Corporate'}</Col>
                        </Row>
                        <Row style={{ marginBottom: '20px' }}>
                            <Col md={4}><strong>Report:</strong></Col>
                            <Col md={8}>
                                <Button color="link" className="p-0" onClick={() => generatePDF(user)}>
                                    Generate PDF Report
                                </Button>
                            </Col>
                        </Row>
                        <div className="text-center">
                            <Button id="editBtn" style={{...theme.button, marginRight: '10px'}} onClick={toggleModal}>
                                Edit Profile
                            </Button>
                            <Button 
                                id="takeTestBtn" 
                                style={theme.button} 
                                onClick={() => props.history.push(`/psychometrictest/${encodeURIComponent(signedEmail)}`)}
                            >
                                Take Test Here
                            </Button>
                        </div>
                    </div>
                </div>
            </div>

            {/* Modal for editing profile */}
            <Modal isOpen={modal} toggle={toggleModal}>
                <ModalHeader toggle={toggleModal}>Edit individual Profile</ModalHeader>
                <ModalBody>
                    <div>First Name: </div>
                    <Input name="firstName" value={individual.firstName} onChange={handleInputChange} placeholder="First Name" />
                    <div>Last Name: </div>
                    <Input name="lastName" value={individual.lastName} onChange={handleInputChange} placeholder="Last Name" />
                    <div>Email: </div>
                    <Input name="email" value={individual.email} onChange={handleInputChange} placeholder="Email" />
                    <div>Mobile: </div>
                    <PhoneInput
                        placeholder="+91 98765-43120"
                        inputClass="form-control"
                        inputStyle={theme.formInput}
                        isValid={(value) => {
                            if (value.slice(0, 2) !== "91") {
                                return false;
                            }
                            return true;
                        }}
                        inputProps={{
                            name: 'mobile',
                            required: true
                        }}
                        country="in"
                        disableDropdown={true}
                        value={individual.mobile}
                        enableSearch={true}
                        onChange={handlePhoneChange}
                    />
                    <div>Test Type: </div>
                    <Input 
                        type="select" 
                        name="isStudent" 
                        value={individual.isStudent} 
                        onChange={handleInputChange}
                    >
                        <option value={true}>Student</option>
                        <option value={false}>Corporate</option>
                    </Input>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary"  style={theme.button} onClick={handleUpdate}>Save Changes</Button>{' '}
                    <Button color="secondary"  style={theme.button} onClick={toggleModal}>Cancel</Button>
                </ModalFooter>
            </Modal>

        </div>
    );
};

export default PyschometricIndividualHomePage;
